import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  constructor(private router: Router) {}
  ngOnInit() {
    const info = localStorage.getItem('transaction') || '';
    if (info) {
      const transaction: any = JSON.parse(info);
      if (transaction) {
        if (transaction.defaultPaymentMethod === 'UNDETERMINED') {
          this.router.navigate(['payment-methods']);
        }
      } else {
        this.router.navigate(['404']);
      }
    }
  }
}
